/**
 * refine is a way to strip all undefined properties from an object. This is particularly useful when wanting to preserve comparability with
 * serialized objects. E.g., dehydrated query input on a <Hydrate> component that gets deserialized and serialized between server and client.
 * */
export const refine = <T>(value: T): T => {
  return JSON.parse(JSON.stringify(value))
}
